import { classes } from '../base/classes.helpers';
import { svgBase, svgSprinkels } from './svg.css';

/**
 * Component to style SVG elements.
 *
 * Responsibilities:
 *
 * 1. Styling of SVG elements.
 * 2. Default SVG's to their cropped version.
 */

export const svg = (props: Parameters<typeof svgSprinkels>[0]) => {
	return classes(svgBase, svgSprinkels(props));
};
